<template>
  <Popup
    v-if="show"
    @close="$emit('close')"
  >
    <template #icon>
      <svg
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
 class="w-5 h-5 text-gray-600">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
    />
</svg>
    </template>

    <template #header>
      Set Delay Date Range
    </template>

    <template #body>
      <div class="flex flex-col space-y-4">
        <label>
          <span class="block text-sm font-medium text-gray-700 mb-1">Start Date</span>

          <AppInput
            v-model="form.start_date"
            name="start_date"
            type="date"
            class="form-input"
            :error="errors.start_date"
          />
        </label>

        <label>
          <span class="block text-sm font-medium text-gray-700 mb-1">End Date</span>

          <AppInput
            v-model="form.end_date"
            name="end_date"
            type="date"
            class="form-input"
            :error="errors.end_date"
          />
        </label>
      </div>
    </template>

    <template #footer>
      <button
        type="button"
        class="btn btn--secondary-blue"
        @click="$emit('close')"
      >
        Cancel
      </button>

      <button
        type="button"
        class="btn btn--primary-blue"
        @click="handleSave"
      >
        Save
      </button>
    </template>
  </Popup>
</template>

<script setup lang="ts">
import Popup from '@/components/Popup.vue';
import { ref, watch } from 'vue';

const props = defineProps<{
  show: boolean;
}>();

const emits = defineEmits<{
  (e: 'close');
  (e: 'save', data: { start_date: string; end_date: string; days: number });
}>();

const form = ref({
  start_date: '',
  end_date: '',
});

const errors = ref({
  start_date: '',
  end_date: '',
});

watch(() => props.show, (newValue) => {
  if(newValue) {
    // Reset form when popup is shown
    form.value.start_date = '';
    form.value.end_date = '';

    errors.value = {
      start_date: '',
      end_date: '',
    };
  }
});

const handleSave = () => {
  // Validate dates
  errors.value = {
    start_date: '',
    end_date: '',
  };

  if(!form.value.start_date) {
    errors.value.start_date = 'Start date is required';

    return;
  }

  if(!form.value.end_date) {
    errors.value.end_date = 'End date is required';

    return;
  }

  const startDate = new Date(form.value.start_date);
  const endDate = new Date(form.value.end_date);

  if(endDate < startDate) {
    errors.value.end_date = 'End date must be after or equal to start date';

    return;
  }

  // Calculate days from dates
  const days = Math.ceil((endDate.getTime() - startDate.getTime()) / (1000 * 60 * 60 * 24));

  // Emit save event with form data and calculated days
  emits('save', {
    start_date: form.value.start_date,
    end_date: form.value.end_date,
    days,
  });
};
</script>

<style scoped></style>
